
import Like from "../../../assets/outline/Like.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function LikeIcon({ className, dataTestid = "LikeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Like data-testid={dataTestid} className={classes} {...rest} />
  );
}
